import React from "react";
import { useHistory } from "react-router-dom";

export const UpsellOrdersComponent = () => {
  const history = useHistory();
  const upsellOrders = () => {
    history.push("/upsellOrders");
  };
  return (
    <div className="text-align-center" onClick={upsellOrders}>
      <span className="font-size-smd bold font-family-default">Upsell Orders</span>
    </div>
  );
};
